import React from 'react'
import { makeStyles, Box, Grid, Typography, Container } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  mainBox: {
    padding: '40px 0px',
  },
}))
export default function AdvBanner() {
  const classes = useStyles()
  return (
    <Box className={classes.mainBox}>
      <Grid container spacing={1}>
        <Grid item lg={12} sm={12} xs={12} md={12}>
          <Container>
            <Typography varinat="h4"></Typography>
            <Box>
              <video controls loop="true" autoplay="true" width="100%">
                <source
                  src="./video/video.mp4"
                  type="video/mp4"
                  style={{
                    border: '1px solid #F83838',
                  }}
                />
              </video>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  )
}
